import { render, staticRenderFns } from "./ReBranchPart.vue?vue&type=template&id=0c8f29f0"
import script from "./ReBranchPart.vue?vue&type=script&lang=js"
export * from "./ReBranchPart.vue?vue&type=script&lang=js"
import style0 from "./ReBranchPart.vue?vue&type=style&index=0&id=0c8f29f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports